// Re-export the complete Theme interface from theme types
// Keep the default breakpoints for backward compatibility
export var defaultBreakpoints = {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
};
// Export defaultTheme for backward compatibility
import { lightTheme } from '../theme/lightTheme';
export var defaultTheme = lightTheme;
